import React,{useEffect} from 'react'
import ReservTwo from '../MainReserv/ReservTwo'
import Aos from 'aos'
import Header from '../Header/Main';
import Footer from '../Footer/Main';

function Main() {

    useEffect(() => {
        window.scrollTo(0,0);
      }, []);

    return (
        <div className='page_wrapper'>
            <Header />
            <ReservTwo/>
            <Footer />
        </div>
    )
}

export default Main